<template>
  <div>
    <alert-error :error="error"></alert-error>

    <v-toolbar>
      <v-toolbar-title>{{ $t('REPORTS.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
    </v-toolbar>

    <item-list v-if="reports" :reports="reports" @show="show" />
  </div>
</template>

<script>
export default {
  name: 'ReportsPage',

  components: {
    ItemList: () => import('@/modules/reports/components/ReportList.vue'),
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  data: () => ({
    error: null
  }),

  computed: {
    reports() {
      return [
        {
          id: 1,
          type: 'customers-habitation',
          name: this.$t('REPORTS.ALL_INHABITANTS_CUSTOMERS')
        },
        {
          id: 2,
          type: 'business-customer-habitation',
          name: this.$t('REPORTS.ALL_INHABITANTS_OF_B_CUSTOMER')
        },
        {
          id: 3,
          type: 'customers-communication-options',
          name: this.$t('REPORTS.COMMUNICATION_OPTIONS')
        },
        {
          id: 4,
          type: 'buildings-analytics',
          name: this.$t('REPORTS.BUILDINGS_ANALYTICS')
        },
        ...(this.$can('sensitive-data')
          ? [
              {
                id: 5,
                type: 'emergency-devices',
                name: this.$t('REPORTS.EMERGENCY_DEVICES')
              }
            ]
          : []),
        {
          id: 6,
          type: 'tasks',
          name: this.$t('REPORTS.TASKS')
        },
        {
          id: 7,
          type: 'invoices',
          name: this.$t('REPORTS.INVOICES')
        },
        ...(this.$can('sensitive-data')
          ? [
              {
                id: 8,
                type: 'medicall',
                name: this.$t('REPORTS.MEDICALL')
              }
            ]
          : []),
        {
          id: 9,
          type: 'business-customer-habitation-history',
          name: this.$t('REPORTS.ALL_INHABITANTS_OF_B_CUSTOMER_HISTORY')
        },
        {
          id: 10,
          type: 'activity-log',
          name: this.$t('REPORTS.ACTIVITY_LOG')
        },
        {
          id: 11,
          type: 'invoices-all-lines',
          name: this.$t('REPORTS.INVOICES_ALL_LINES')
        },
        {
          id: 12,
          type: 'magazine',
          name: this.$t('REPORTS.MAGAZINE')
        }
      ];
    }
  },

  methods: {
    show(item) {
      this.$router.push({
        name: 'reports.export',
        params: { type: item.type }
      });
    }
  }
};
</script>
